import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_10 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_11 = { class: "col-sm" }
const _hoisted_12 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_16 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_17 = { class: "col-sm" }
const _hoisted_18 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_23 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_26 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_27 = { class: "col-sm" }
const _hoisted_28 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_29 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_30 = { class: "col-sm" }
const _hoisted_31 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_32 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_33 = { class: "col-sm" }
const _hoisted_34 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_35 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_36 = { class: "col-sm" }
const _hoisted_37 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_38 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_39 = { class: "col-sm" }
const _hoisted_40 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_41 = { class: "control-label col-sm-6" }
const _hoisted_42 = { class: "col-sm" }
const _hoisted_43 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_44 = { class: "control-label col-sm-6" }
const _hoisted_45 = { class: "col-sm" }

import { watch , ref, inject } from 'vue'
import { usePreventivo } from '../../composable/usePreventivo';
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareAttiDichiarativi',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo();
const props = __props;
const validazioneEquoCompenso = ref();
const testoInfoCompilazione = ref([]);
const { regimeFiscale } = inject('regimeFiscale')
const emits = __emit;
let validazione;
switch (props.formName) {
  case 'vincoloUrbanisticoEdilizio':
    validazione = categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['vincoloUrbanisticoEdilizio'];
    validazioneEquoCompenso.value =  categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['vincoloUrbanisticoEdilizio'];
    break
  case 'convenzionePerLoSvincoloDalPrezzoMassimoDiCessione':
    validazione = categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['convenzionePerLoSvincoloDalPrezzoMassimoDiCessione'];
    validazioneEquoCompenso.value =  categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['convenzionePerLoSvincoloDalPrezzoMassimoDiCessione'];
    break
  case 'preliminareDiVendita':
    validazione = categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['preliminareDiVendita'];
    validazioneEquoCompenso.value =  categorieValidazione.categoriaImmobiliare['sottocategoriaAttiDichiarativi']['preliminareDiVendita'];
    break
}
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaAttiDichiarativi[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if(validazione){
  validazione.tipo_preventivo.value = 'immobiliare/atti_dichiarativi/' + props.tipoPreventivo.data.url
}
let indexHelperClosing = {
  calcolo: FormImmobiliareHelper.sottocategoriaAttiDichiarativi[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
watch(validazione, () => {
  emits('changeDatiPreventivo')
}, { deep: true });

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_select = _resolveComponent("base-select")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'vincoloUrbanisticoEdilizio')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_trascrizioni.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_trascrizioni.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "numero_trascrizioni",
                name: "numero_trascrizioni",
                class: "placeholder-right",
                placeholder: "0,00",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_trascrizioni,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).numero_trascrizioni) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) === 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_input_checkbox, {
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'convenzionePerLoSvincoloDalPrezzoMassimoDiCessione')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(validazione).corrispettivo_determinato.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.corrispettivo_determinato.ref]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_base_input_text, {
                  id: "corrispettivo_determinato",
                  name: "corrispettivo_determinato",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).corrispettivo_determinato,
                  "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).corrispettivo_determinato) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_base_select, {
                  name: "forma_del_titolo",
                  options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                  isSelected: _unref(validazione).forma_del_titolo.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).forma_del_titolo,
                  "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_trascrizioni.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_trascrizioni.ref]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_base_input_text, {
                  id: "numero_trascrizioni",
                  name: "numero_trascrizioni",
                  class: "placeholder-right",
                  placeholder: "Indicare il numero di trascrizioni",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_trascrizioni,
                  "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).numero_trascrizioni) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_base_input_checkbox, {
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly,
              "filter-options-d": true
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'preliminareDiVendita')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore.ref]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_base_input_text, {
                    id: "valore",
                    name: "valore",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_caparra_confirmatoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_caparra_confirmatoria.ref]
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_caparra_confirmatoria",
                    name: "valore_caparra_confirmatoria",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_caparra_confirmatoria,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_caparra_confirmatoria) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_acconto_prezzo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_acconto_prezzo.ref]
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_acconto_prezzo",
                    name: "valore_acconto_prezzo",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_acconto_prezzo,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_acconto_prezzo) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_conservatorie",
                    name: "numero_conservatorie",
                    class: "placeholder-right text-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_conservatorie,
                    "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_unref(validazione).dichiarazione_di_nomina.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.dichiarazione_di_nomina.ref]
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_base_select, {
                    name: "dichiarazione_di_nomina",
                    options: [{name: 'Solo registrata', value: 'solo_registrata'},{name: 'Registrata e trascritta', value: 'registrata_e_trascritta'}],
                    isSelected: _unref(validazione).dichiarazione_di_nomina.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).dichiarazione_di_nomina,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).dichiarazione_di_nomina) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_38, [
                  _createTextVNode(_toDisplayString(_unref(validazione).passivo_iva.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.passivo_iva.ref]
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_base_input_checkbox, {
                    name: "passivo_iva",
                    label: "è soggetto passivo IVA",
                    "validate-to": _unref(validazione).passivo_iva,
                    "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).passivo_iva) = $event))
                  }, null, 8 /* PROPS */, ["validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_base_select, {
                    name: "forma_del_titolo",
                    options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                    isSelected: _unref(validazione).forma_del_titolo.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).forma_del_titolo,
                    "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(regimeFiscale) === 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_44, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_base_input_checkbox, {
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "valore",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}